import { useFunction } from "@project-rouge/rg-three";
import { useMemo, useState } from "react";
function useMemoState(initialState, dependencies = [initialState]) {
	const memoDeps = useMemo(() => dependencies, dependencies);
	const [_state, _setState] = useState({
		value: initialState,
		memoDeps
	});
	const setState = useFunction((value) => _setState({
		value,
		memoDeps
	}));
	return [memoDeps === _state.memoDeps ? _state.value : initialState, setState];
}
export { useMemoState };

//# sourceMappingURL=index205.js.map